import React from 'react';
import { AvatarGroup } from "@mui/material";
import UserAvatar from './UserAvatar';

const AvatarGroupList = ({ 
  users, 
  setAnchorEl, 
  isColabrotar, 
  selectedUsers, 
  filterUserById,
  boardOwnerId 
}) => {
  return (
    <AvatarGroup
      total={users?.length}
      renderSurplus={(surplus) => (
        <span onClick={setAnchorEl}>
          +{users?.length - 4}
        </span>
      )}
      className="avatar-group cursor-pointer avatar-group-border">
      {users?.map((user) => (
        <UserAvatar
          key={`user-avtar-${user.user_id}`}
          user={user}
          isColabrotar={isColabrotar}
          selectedUsers={selectedUsers}
          filterUserById={filterUserById}
          boardOwnerId={boardOwnerId}
        />
      ))}
    </AvatarGroup>
  );
};

export default AvatarGroupList; 
